import { MinpakuHeader } from "../../components/header/minpaku.header";
import { Keypad } from "../../../../components/layout/keypad";
import AnimatedPageTransition from "../../../../../domain/module/navigation/animated-page-transition";

export const MinpakuKeypadPage = () => {
  return (
    <AnimatedPageTransition>
      <div className="bg-white pt-5 h-[calc(var(--vh,1vh)*100)] text-white pb-8 flex flex-col">
        <MinpakuHeader />
        {/* eslint-disable-next-line @typescript-eslint/no-empty-function */}
        <Keypad onComplete={() => {}} />
      </div>
    </AnimatedPageTransition>
  );
};
